import styled from "styled-components";

const CreateAndEditCategoryContainer = styled.div``;

export { CreateAndEditCategoryContainer };
